<div class="header">
  <button mat-icon-button (click)="toggle()" class="expand-button">
    <mat-icon>{{ isExpanded() ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}</mat-icon>
  </button>
  @if (isExpanded()) {
    <ng-content select="crm-dropdown-header[onState='expanded']"></ng-content>
  } @else {
    <ng-content select="crm-dropdown-header[onState='collapsed']"></ng-content>
  }
  @if (actions?.length) {
    <button mat-icon-button [matMenuTriggerFor]="menu" class="actions-button">
      <mat-icon>more_vert</mat-icon>
    </button>
  }
</div>

@if (isExpanded()) {
  <div class="expanded-content">
    <ng-content select="crm-dropdown-content[onState='expanded']"></ng-content>
  </div>
} @else {
  <div class="collapsed-content" (click)="open()">
    <ng-content select="crm-dropdown-content[onState='collapsed']"></ng-content>
  </div>
}

<mat-menu #menu="matMenu">
  @for (action of actions; track $index) {
    <button mat-menu-item (click)="action.callback()">
      <span>{{ action.label | translate }}</span>
    </button>
  }
</mat-menu>
